<template>
<div class="webbox webbox_bj6">
    <div class="webbox_con">
    </div>
</div>
</template>
<script>
    export default {
        data() {
            return {
                // 公告列表数据
                dataList: [],
                pageSize: 10,
            };
        },
        mounted() {
        },
        methods: {

        },
    };
</script>
<style lang="scss" scoped>
@charset "utf-8";
/* LLK CSS Document */
*{ margin:0px; padding:0px; color: #535353;font-family: 微软雅黑; box-sizing: border-box;outline: none}
html, body { height: 100%; min-width: 1002px; }
fieldset, img { border: 0; }
li { list-style: none; }
a { color: #535353; text-decoration: none; }
a:hover { color: #0473d9;transition: all 0.2s ease-in-out 0s;}
table { border-collapse: collapse; border-spacing: 0; }
.table_fix { table-layout: fixed; }
.clear { clear: both; line-height: 0px; font-size: 0px; height: 0px }
.clearfix:before, .clearfix:after { content: ""; display: table; }
.clearfix:after { clear: both; overflow: hidden; }
.clearfix { *zoom:1;
}
.zong_tagContent .tagContent { display: none; }
.zong_tagContent .selectTag { display: block; }
.rel { position: relative }
.abs { position: absolute }
.align_c { text-align: center }
.f_l { float: left }
.f_r { float: right }
.webbox{}
.webbox_bj1{background: url("../../../assets/images/compliance/shouye.png") no-repeat center top;height: 850px}
.webbox_bj2{background: url("../../../assets/images/compliance/gengduo.png") no-repeat center top;height: 850px}
.webbox_bj3{background: url("../../../assets/images/compliance/jiuyeqiuzhi.png") no-repeat center top;height: 850px}
.webbox_bj4{background: url("../../../assets/images/compliance/jiuyeqiuzhixiangqing.png") no-repeat center top;height: 850px}
.webbox_bj5{background: url("../../../assets/images/compliance/zhiyexuexiao.png") no-repeat center top;height: 850px}
.webbox_bj6{background: url("../../../assets/images/compliance/zhiyexuexiaoxiangqing.png") no-repeat center top;height: 850px}
.webbox_bj7{background: url("../../../assets/images/compliance/zhaopin.png") no-repeat center top;height: 850px}
.webbox_bj8{background: url("../../../assets/images/compliance/zhaopinxingqing.png") no-repeat center top;height: 850px}
.webbox_con{width: 1200px;position: relative;margin: 0px auto;}
.shouye{display: inline-block;position: absolute;width: 300px;height: 40px;top:0px;left: -307px;}
.qitafuwu{width: 600px;height: 310px;position: relative;/*! background: #ddd; */top:1229px;left: 0px;}
.qitafuwu a{display: inline-block;position: absolute;background-color: rgba(255,255,255,0)}
.weblink1{width:60px;height: 40px;top:3px;right: 11px; }
.weblink2{width:174px;height: 174px;top:86px;left: 20px; }
.weblink3{width:174px;height: 174px;top:86px;left:210px; }
.weblink4{width:174px;height: 174px;top:86px;left:403px; }
.qitafuwu a:hover{background-color: rgba(255,255,255,0.25)}
.weblink5{width:266px;height: 143px;top:329px;left:272px; display: inline-block;position: absolute;background-color: rgba(255,255,255,0)}
.weblink6{width:360px;height: 120px;top:290px;left:40px;display: inline-block;position: absolute; background-color: rgba(255,255,255,0)}
.weblink7{width:1200px;height: 120px;top:250px;left:0px;display: inline-block;position: absolute;background-color: rgba(255,255,255,0) }
.weblink5:hover,.weblink6:hover,.weblink7:hover{background-color: rgba(255,255,255,0.15)}
</style>
